import { config } from 'config'
import { useMutation, useQuery } from 'react-query'
import { GetCompanyRequest, GetCompanyResponse } from 'types/getCompany'
import { callAxios, CustomAxiosError } from 'utils/api'

const { SECURE_BASE_URL } = config!

const getQueryParams = (props: GetCompanyRequest) => {
  const { companyName, companyType } = props

  let queryParams = `supplierName=${encodeURIComponent(companyName.toUpperCase())}`

  if (companyType) queryParams += `&supplierType=${companyType}`
  queryParams += '&operation=listSupplier'

  return queryParams
}

const getCompany = async (props: GetCompanyRequest): Promise<GetCompanyResponse> => {
  const { bypassTokenVerification } = props

  const { response: companyResponse } = await callAxios<{
    response: { data: GetCompanyResponse }
  }>({
    url: `${SECURE_BASE_URL}${bypassTokenVerification ? '/register' : ''}/listsupplier?${getQueryParams(props)}`,
    method: 'GET',
  })

  const mappedResponse: GetCompanyResponse =
    companyResponse?.data?.map((item: any): GetCompanyResponse[number] => ({
      companyName: item?.supplierName ?? '',
      companyType: item?.supplierType ?? '',
      roles: item?.roles ?? [],
      oracleId: item?.oracleId,
      supplierId: item?.id,
      relatedGroup: item?.relatedGroup,
      relatedSuppliers: item?.relatedGroupRelatedSuppliers?.map((relatedSupplier: any) => ({
        supplierName: relatedSupplier.supplier_name,
        oracleId: relatedSupplier.oracle_id,
      })),
    })) ?? []

  return mappedResponse
}

export const useGetCompany = (props: GetCompanyRequest) => {
  const {
    status: getCompanyStatus,
    data: getCompanyData,
    error: getCompanyError,
  } = useQuery<GetCompanyResponse, CustomAxiosError>(['company/get', props], () => getCompany(props), {
    enabled: props.companyName.length >= 3,
  })

  return { getCompanyStatus, getCompanyData, getCompanyError }
}

const getTaggedUsers = async (groupId: string) => {
  const { response: taggedUsersResponse } = await callAxios<{
    response: any[]
  }>({
    url: `${SECURE_BASE_URL}/taggedUsers?id=${groupId}&operation=chTaggedUsers`,
    method: 'GET',
  })

  return taggedUsersResponse
}

export const useGetTaggedUsers = () => {
  const {
    status: getTaggedUsersStatus,
    data: getTaggedUsersData,
    error: getTaggedUsersError,
    mutate: mutateTaggedUsers,
    reset: resetTaggedUsers,
  } = useMutation<any[], CustomAxiosError, string>(getTaggedUsers)

  return {
    getTaggedUsersStatus,
    getTaggedUsersData,
    getTaggedUsersError,
    mutateTaggedUsers,
    resetTaggedUsers,
  }
}
